import { Display1, LeaderIcon, TinyTitleBold, theme } from '@kvdbil/components';
import React from 'react';
import styled from 'styled-components';
import { useTranslation } from '~/Locale';

const Container = styled.div`
  width: 100%;
  height: 96px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px;
`;

const IconContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.primary.mainAlt};
  width: 64px;
  height: 64px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const TextContainer = styled.div`
  text-align: center;
`;

function Congratulations() {
  const { t } = useTranslation();

  return (
    <Container>
      <IconContainer>
        <LeaderIcon
          height={'32px'}
          width={'32px'}
          color={theme.colors.primary.lighter2}
        />
      </IconContainer>

      <TextContainer>
        <Display1>{t('Congrats')}</Display1>
        <TinyTitleBold>{t('You won the bidding')}!</TinyTitleBold>
      </TextContainer>

      <IconContainer>
        <LeaderIcon
          height={'32px'}
          width={'32px'}
          color={theme.colors.primary.lighter2}
        />
      </IconContainer>
    </Container>
  );
}

export default Congratulations;
